<template>
    <div class="form-agency-details">
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="name">Name*</label>
                    <input class="js-input-agency-name" v-model="agency_name" type="text" id="name" name="name" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--label" style="padding-right: 24px">
                    <label>Created</label>
                    {{ created }}
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--tree" style="padding-right: 24px">
                    <label for="company_type">Status</label>

                    <input type="hidden" name="status_id" v-model="status"
                        v-if="!status || (status && status.length <= 0)">
                    <treeselect :clearOnSelect="true" v-model="status" id="status" :name="'status_id'"
                        placeholder="Choose status" :multiple="false" :options="statusOptions" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="name_in_quickbooks">Name in Quickbooks</label>
                    <input class="js-input-name-in-quickbooks" type="text" id="name_in_quickbooks"
                        name="name_in_quickbooks" v-model="name_in_quickbooks" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--contact" style="padding-right: 24px" v-if="sale_contact">
                    <label>Sales contact:</label>
                    <p class="name" v-if="sale_contact.name || sale_contact.lastname">
                        {{ `${sale_contact.name} ${sale_contact.lastname}` }}
                    </p>
                    <p class="email">
                        <a :href="`mailto:${sale_contact.email}`">Write an e-mail</a>
                    </p>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--tree" style="padding-right: 24px">
                    <label for="company_type">Source</label>

                    <input type="hidden" name="source_id" v-model="source"
                        v-if="!source || (source && source.length <= 0)">
                    <treeselect :clearOnSelect="true" v-model="source" id="source" :name="'source_id'"
                        placeholder="Choose source" :multiple="false" :options="sourceOptions" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--tree" style="padding-right: 24px">
                    <label for="company_type">Company type</label>

                    <input type="hidden" name="company_type_id" v-model="company_type"
                        v-if="!company_type || (company_type && company_type.length <= 0)">
                    <treeselect v-model="company_type" id="company_type" :name="'company_type_id'"
                        placeholder="Choose type" :multiple="false" :options="company_types" :clearOnSelect="true" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="website">Website</label>
                    <input v-model="website" type="text" id="website" name="website" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--modal form-field--tree" style="padding-right: 24px">
                    <label for="industry">Industry
                        <span @click="toggleIndustryModal">Add new</span></label>
                    <input type="hidden" name="industries" v-model="industry"
                        v-if="!industry || (industry && industry.length <= 0)">
                    <treeselect id="industry" v-model="industry" :multiple="true" :valueConsistsOf="'ALL'"
                        name="industries[]" :options="industriesOptions" @select="handleChanged" @input="handleChanged"
                        @deselect="handleChanged" :clearOnSelect="true" />
                    <AddIndustryModal v-if="isOpenIndustryModal" :onClose="toggleIndustryModal" :onAdd="addIndustry"
                        :clearOnSelect="true" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--modal form-field--tree" style="padding-right: 24px">
                    <label for="niche">Niche
                        <span @click="toggleNicheModal">Add new</span></label>
                    <input type="hidden" name="niches" v-model="niche" v-if="!niche || (niche && niche.length <= 0)">
                    <treeselect :clearOnSelect="true" id="niche" v-model="niche" :multiple="true"
                        :valueConsistsOf="'ALL'" name="niches[]" :options="nicheOptions" @select="handleChanged"
                        @input="handleChanged" @deselect="handleChanged" />
                    <AddNicheModal v-if="isOpenNicheModal" :onClose="toggleNicheModal" :onAdd="addNiche" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="industries_verticals">Industries / verticals</label>
                    <textarea style="height: 120px" readonly v-model="industries_verticals" type="text"
                        id="industries_verticals" name="industries_verticals"></textarea>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="specialty">Specialty or niche service offerings</label>
                    <textarea style="height: 120px" readonly v-model="specialty" type="text" id="specialty"
                        name="specialty"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="number_of_employees">Number of employees</label>
                    <input type="text" v-model="number_of_employees" name="number_of_employees"
                        id="number_of_employees" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="year_founded">Year founded</label>
                    <input type="text" maxlength="4" name="year_founded" v-model="year_founded" id="year_founded"
                        @input="calculateFoundedYears" />
                    <span style="left: 0" v-if="errors.year_founded" class="error">{{ errors.year_founded }}</span>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--label form-field--founded" style="padding-right: 24px">
                    <label>Years in business</label>
                    <span class="value">{{ years_in_business }}</span>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="row">
                    <div class="col-xl-6 col-lg-6">
                        <div class="form-field form-field--text" style="padding-right: 24px">
                            <label for="min_contract_length">Minimum Contract Length</label>
                            <input type="text" v-model="minimum_contract_length" name="minimum_contract_length"
                                id="min_contract_length" />
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="form-field form-field--text" style="padding-right: 24px">
                            <label for="blended_hourly_rate">Blended Hourly rate</label>
                            <input hidden v-model="blended_hourly_rate" name="blended_hourly_rate"
                                id="blended_hourly_rate" />
                            <CurrencyInput :id="'blended_hourly_rate_currency'" :name="'blended_hourly_rate_currency'"
                                v-model="blended_hourly_rate" :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-4">
                <div class="row">
                    <div class="col-xl-6 col-lg-6">
                        <div class="form-field form-field--text" style="padding-right: 24px">
                            <label for="minimum_project_budget">Minimum project budget</label>
                            <input hidden v-model="minimum_project_budget" name="minimum_project_budget"
                                id="minimum_project_budget" />
                            <CurrencyInput :disabled="mpb_not_applicable" :id="'minimum_project_budget_currency'"
                                :name="'minimum_project_budget_currency'" v-model="minimum_project_budget" :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }" />
                        </div>

                        <div style="min-width: 100%" class="form-field checkbox-wrap">
                            <input v-model="mpb_not_applicable" type="checkbox" id="mpb_not_applicable"
                                name="mpb_not_applicable" />
                            <label for="mpb_not_applicable"><i class="icon icon-checkmark"></i></label>
                            Not Applicable
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="form-field form-field--text" style="padding-right: 24px">
                            <label style="width: 230px;" for="minimum_monthly_retainer_fee">Minimum monthly retainer
                                fee</label>
                            <input hidden v-model="minimum_monthly_retainer_fee" name="minimum_monthly_retainer_fee"
                                id="minimum_monthly_retainer_fee" />
                            <CurrencyInput :disabled="mmrf_not_applicable" :id="'minimum_monthly_retainer_fee_currency'"
                                :name="'minimum_monthly_retainer_fee_currency'" v-model="minimum_monthly_retainer_fee"
                                :options="{
                                    currency: 'USD',
                                    hideCurrencySymbolOnFocus: false,
                                    hideGroupingSeparatorOnFocus: false,
                                    hideNegligibleDecimalDigitsOnFocus: false,
                                }" />
                        </div>
                        <div style="min-width: 100%" class="form-field checkbox-wrap">
                            <input v-model="mmrf_not_applicable" type="checkbox" id="mmrf_not_applicable"
                                name="mmrf_not_applicable" />
                            <label for="mmrf_not_applicable"><i class="icon icon-checkmark"></i></label>
                            Not Applicable
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4"></div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="annual_gross_revenue_list">Annual gross revenue</label>
                    <input type="hidden" name="annual_gross_revenue_list" v-model="annual_gross_revenue"
                        v-if="!annual_gross_revenue || (annual_gross_revenue && annual_gross_revenue.length <= 0)">
                    <treeselect id="annual_gross_revenue_list" v-model="annual_gross_revenue"
                        name="annual_gross_revenue_list" :options="annual_gross_revenue_options"
                        :clearOnSelect="true" />
                </div>
            </div>
            <div class="col-xl-2 col-lg-2">
                <div class="form-field form-field--text" style="padding-right: 24px">
                    <label for="annual_gross_revenue">Annual gross revenue</label>
                    <input type="text" hidden v-model="annual_gross_revenue_custom" name="annual_gross_revenue"
                        id="annual_gross_revenue" />
                    <CurrencyInput :id="'annual_gross_revenue_currency'" :name="'annual_gross_revenue_currency'"
                        v-model="annual_gross_revenue_custom" :options="{
                            currency: 'USD',
                            hideCurrencySymbolOnFocus: false,
                            hideGroupingSeparatorOnFocus: false,
                            hideNegligibleDecimalDigitsOnFocus: false,
                        }" />
                    <!-- <input
                        type="text"
                        v-model="annual_gross_revenue_custom"
                        name="annual_gross_revenue"
                        id="annual_gross_revenue"
                    /> -->
                </div>
            </div>
            <div class="col-xl-2 col-lg-2"></div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree form-field--tree-not-nowrap">
                    <label for="office-type">Office type</label>
                    <treeselect id="office-type" v-model="office_type" :multiple="false" name="office_type"
                        :options="data_office_types" @select="handleChanged" :clearOnSelect="false"
                        @input="handleChanged" @deselect="handleChanged" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="client-size">Client size</label>
                    <input type="hidden" name="client_sizes" v-model="client_size"
                        v-if="!client_size || (client_size && client_size.length <= 0)">
                    <treeselect id="client-size" v-model="client_size" :multiple="true" :valueConsistsOf="'ALL'"
                        name="client_sizes[]" :options="clientSizes" @select="handleChanged" :clearOnSelect="true"
                        @input="handleChanged" @deselect="handleChanged" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="lang">Additional language(-s)</label>
                    <input type="hidden" name="languages" v-model="lang" v-if="!lang || (lang && lang.length <= 0)">
                    <treeselect id="lang" v-model="lang" :multiple="true" :valueConsistsOf="'ALL'" name="languages[]"
                        :clearOnSelect="true" :options="languages" @select="handleChanged" @input="handleChanged"
                        @deselect="handleChanged" />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--modal form-field--tree">
                    <label for="location">Locations <span @click="toggleLocationModal">Add new</span></label></label>
                    <input type="hidden" name="locations" v-model="location"
                        v-if="!location || (location && location.length <= 0)">
                    <treeselect id="location" v-model="location" :multiple="true" :valueConsistsOf="'ALL'"
                        :clearOnSelect="true" name="locations[]" :options="locationOptions" />
                    <AddLocationModal v-if="isOpenLocationModal" :onClose="toggleLocationModal" :onAdd="addLocation"
                        :locationsOptions="locationOptions" :locationTypeOptions="locationTypeOptions" />
                </div>
                <div class="form-field checkbox-wrap" style="margin-bottom: 0px">
                    <input v-model="remote_office" @change="onChangeRemoteOffice" type="checkbox" id="remote_office"
                        name="remote_office" />
                    <label for="remote_office"><i class="icon icon-checkmark"></i></label>
                    Only remote
                </div>
            </div>

            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="lang">What social media properties would you like us to tag in our posts about your
                        appearance on our show?</label>
                    <input type="hidden" name="languages" v-model="socialMedia"
                        v-if="!socialMedia || (socialMedia && socialMedia.length <= 0)">
                    <treeselect id="lang" v-model="socialMedia" :multiple="true" :valueConsistsOf="'ALL'"
                        name="social_media[]" :clearOnSelect="true" :options="social_media_list" @select="handleChanged"
                        @input="handleChanged" @deselect="handleChanged" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import moment from "moment";
import { set_is_changed } from "../../helpers/_check_unsaved";
import AddIndustryModal from "../BusinessTab/modals/AddIndustry.vue";
import AddNicheModal from "../BusinessTab/modals/AddNiche.vue";
import AddLocationModal from "../BusinessTab/modals/AddLocation.vue";
import CurrencyInput from "../CurrencyInput";

export default {
    name: "detailsTab",
    props: [
        "agency_name",
        "agency_created",
        "agency_sale_contact",
        "agency_name_in_quickbooks",
        "agency_company_types",
        "agency_company_type",
        "agency_website",
        "agency_minimum_contract_length",
        "agency_year_founded",
        "agency_number_of_employees",
        "agency_source",
        "niches",
        "agency_niches",
        "industries",
        "agency_industries",
        "company",
        "agency_blended_hourly_rate",
        "agency_annual_gross_revenue",
        "agency_annual_gross_revenue_custom",
        "agency_min_project_budget",
        "agency_min_monthly_fee",
        "annualGrossRevenues",
        "annual_gross_revenue_options",
        "clientSizes",
        "agencyClientSizes",
        "locations",
        "location_types",
        "agencyLocations",
        "agency_remote_office",
        "languages",
        "social_media_list",
        "agencyLanguages",
        "agencySocialMedia",
        "sources",
        "agency_status",
        "statuses",
        "google_industries_verticals",
        "google_specialty",
        "industries_verticals_data",
        "specialty_data",
        "mpb_not_applicable_data",
        "mmrf_not_applicable_data",
        "agency_office_types",
        "google_office_description",
    ],
    components: {
        Treeselect,
        AddIndustryModal,
        AddNicheModal,
        AddLocationModal,
        CurrencyInput,
    },
    data() {
        return {
            name: "",
            created: "",
            sale_contact: "",
            name_in_quickbooks: "",
            company_type: null,
            website: "",
            industry: [],
            niche: [],
            status: null,
            number_of_employees: "",
            year_founded: "",
            years_in_business: 0,
            annual_gross_revenue: null,
            annual_gross_revenue_custom: 0,
            blended_hourly_rate: 0,
            minimum_contract_length: "",
            minimum_project_budget: "",
            minimum_monthly_retainer_fee: "",
            lang: null,
            socialMedia: null,
            client_size: null,
            location: null,
            source: null,
            errors: {
                year_founded: false,
            },
            industriesOptions: [],
            nicheOptions: [],
            statusOptions: [],
            locationOptions: [],
            locationTypeOptions: [],
            isOpenIndustryModal: false,
            isOpenNicheModal: false,
            isOpenLocationModal: false,

            is_uploaded: false,

            industries_verticals: "",
            specialty: "",
            remote_office: this.agency_remote_office,

            mpb_not_applicable: this.mpb_not_applicable_data ?? false,
            mmrf_not_applicable: this.mmrf_not_applicable_data ?? false,

            data_office_types: this.agency_office_types ?? [],
            office_type: null,
        };
    },

    watch: {
        mpb_not_applicable(val) {
            this.minimum_project_budget = 0;
        },
        mmrf_not_applicable(val) {
            this.minimum_monthly_retainer_fee = 0;
        },
    },
    computed: {
        company_types() {
            return this.agency_company_types.length
                ? this.agency_company_types.map((type) => {
                    return {
                        id: type.id,
                        label: type.name,
                    };
                })
                : [];
        },
        sourceOptions() {
            return this.sources.length
                ? this.sources.map((source) => {
                    return {
                        id: source.id,
                        label: source.name,
                    };
                })
                : [];
        },
    },
    mounted() {
        this.name = this.agency_name;
        this.created = moment(this.agency_created, "MM.DD.YYYY").format(
            "MM/DD/YYYY"
        );
        this.sale_contact = this.agency_sale_contact;
        this.name_in_quickbooks = this.agency_name_in_quickbooks;
        this.website = this.agency_website;
        this.industry = this.agency_industries;
        this.niche = this.agency_niches;
        this.source =
            this.agency_source ||
            this.sources.find((source) => source.is_default === 1).id ||
            null;
        this.status = this.agency_status || null;
        this.industriesOptions = this.industries;
        this.nicheOptions = this.niches;
        this.statusOptions = this.statuses || [];
        this.locationOptions = this.locations || [];
        this.locationTypeOptions = this.location_types || [];
        this.annual_gross_revenue_custom = this.agency_annual_gross_revenue_custom;
        this.blended_hourly_rate = this.agency_blended_hourly_rate;
        this.minimum_contract_length = this.agency_minimum_contract_length;
        this.year_founded = this.agency_year_founded;
        this.number_of_employees = this.agency_number_of_employees;

        this.minimum_project_budget = this.agency_min_project_budget;
        this.minimum_monthly_retainer_fee = this.agency_min_monthly_fee;
        const __company_type = this.agency_company_types.find(
            (type) => type.id === Number(this.agency_company_type)
        );
        if (__company_type) {
            this.company_type = __company_type.id;
        }
        else {
            this.company_type = 1;
        }

        if (this.company) {
            const __annual_gross_revenue =
                this.annual_gross_revenue_options.find(
                    (option) =>
                        option.id === Number(this.agency_annual_gross_revenue)
                );
            this.annual_gross_revenue = __annual_gross_revenue
                ? __annual_gross_revenue.id
                : null;
        }

        this.lang = this.agencyLanguages ? this.agencyLanguages : null;
        this.socialMedia = this.agencySocialMedia ? this.agencySocialMedia : null;
        (this.client_size = this.agencyClientSizes
            ? this.agencyClientSizes
            : null),
            (this.location = this.agencyLocations
                ? this.agencyLocations
                : null)

        if (
            typeof this.year_founded !== "string" &&
            (this.year_founded === 0 ||
            this.year_founded < 1900 ||
            this.year_founded > new Date().getFullYear())
        ) {
            this.year_founded = new Date().getFullYear();
        }

        this.industries_verticals = this.google_industries_verticals
            ? this.google_industries_verticals
            : this.industries_verticals_data ?? "";
        this.specialty = this.google_specialty
            ? this.google_specialty
            : this.specialty_data ?? "";

        setTimeout(() => {
            this.is_uploaded = true;
        }, 1000);

        this.office_type = this.data_office_types.find(office_t => office_t.label === this.google_office_description).id;

    },
    methods: {
        addIndustry(params) {
            axios
                .post("/industry/create", params)
                .then((res) => {
                    if (res.data) {
                        const new_data = res.data.industries.map((ind) => ({
                            id: ind.id,
                            label: ind.label,
                        }));

                        const new_item = res.data.industries.find(
                            (ind) => ind.label === params.name
                        );

                        this.industriesOptions = [...new_data];
                        this.industry.push(new_item.id);
                        this.isOpenIndustryModal = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        addNiche(params) {
            axios
                .post("/niche/create", params)
                .then((res) => {
                    if (res.data) {
                        const new_data = res.data.niches.map((ind) => ({
                            id: ind.id,
                            label: ind.label,
                        }));

                        const new_item = res.data.niches.find(
                            (ind) => ind.label === params.name
                        );

                        this.nicheOptions = [...new_data];
                        this.niche.push(new_item.id);
                        this.isOpenNicheModal = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        addLocation(params) {
            axios
                .post("/location/create", params)
                .then((res) => {
                    if (res.data) {
                        const new_data = {
                            id: res.data.location.id,
                            label: res.data.location.name
                        }

                        this.locationOptions.push(new_data);
                        this.location.push(new_data.id);
                        this.isOpenLocationModal = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        calculateFoundedYears() {
            const year = this.year_founded.toString();

            this.errors.year_founded = null;

            if (year === 0) {
                return;
            }

            if (year.length < 4) {
                this.errors.year_founded = "Please enter a full year";
            }

            if (year.length === 4 && Number(year) < 1900) {
                this.errors.year_founded = "The minimum year is 1900";
            }

            if (year.length === 4 && Number(year) > new Date().getFullYear()) {
                this.errors.year_founded = `The maximum year is ${new Date().getFullYear()}`;
            }

            if (year.length === 4) {
                const today = new Date();
                const founded_data = new Date(year, 0, 1);

                let today_year = today.getFullYear(),
                    today_month = today.getMonth() + 1,
                    today_date = today.getDate();

                let founded_year = founded_data.getFullYear(),
                    founded_month = founded_data.getMonth() + 1,
                    founded_date = founded_data.getDate();

                let fyear = Number.parseFloat(founded_year),
                    fmonth = Number.parseFloat(founded_month),
                    fdate = Number.parseFloat(founded_date),
                    tyear = Number.parseFloat(today_year),
                    tmonth = Number.parseFloat(today_month),
                    tdate = Number.parseFloat(today_date);

                if (Number(`${tyear - fyear}`) < 0) {
                    this.year_founded = today.getFullYear();
                    this.years_in_business = 0;
                    this.errors.year_founded = null;
                    return;
                }

                this.years_in_business = Number(`${tyear - fyear}`);
            }
        },
        handleChanged() {
            if (this.is_uploaded) set_is_changed();
        },
        toggleIndustryModal() {
            this.isOpenIndustryModal = !this.isOpenIndustryModal;
        },
        toggleNicheModal() {
            this.isOpenNicheModal = !this.isOpenNicheModal;
        },
        toggleLocationModal() {
            this.isOpenLocationModal = !this.isOpenLocationModal;
        },

        onChangeRemoteOffice(e) {
            if (e.target.checked) {
                this.remote_office = true;
            } else {
                this.remote_office = false;
            }
        },
    },
};
</script>
